/* Maren Wells — swipe gallery (2026-09-27). One behaviour for the homepage
   hero jars and the sample kit's scenes (Jin: let people swipe through
   different logos).

   <div data-mw-swipe data-mw-auto="4000">
     <div class="mwu-swipe__track" data-mw-track> ...one child per slide... </div>
     <button data-mw-prev> <button data-mw-next>      (optional)
     <div class="mwu-dots" data-mw-dots></div>         (optional, filled here)
   </div>

   The track is a CSS scroll-snap row, so swiping and trackpads work with no
   script at all; this adds the dots, the arrows and an optional gentle
   auto-advance that stops for good the moment someone touches it, and never
   runs for people who ask for reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.mwSwipeReady) return;
    root.dataset.mwSwipeReady = '1';
    var track = root.querySelector('[data-mw-track]');
    if (!track) return;
    var n = track.children.length;
    if (n < 2) return;
    var cur = 0, timer = null, settle = null;
    var dotsBox = root.querySelector('[data-mw-dots]');
    var dots = [];

    function paint() {
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
    }
    /* The slide is known the moment an arrow or dot is pressed, not when the
       scroll events catch up; browsers may deliver those late or batch them,
       and "next" would otherwise keep landing on slide two. */
    function go(i) {
      cur = (i + n) % n;
      paint();
      track.scrollTo({ left: cur * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    function sync() {
      cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      paint();
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (dotsBox) {
      for (var k = 0; k < n; k++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show ' + (k + 1) + ' of ' + n);
        b.addEventListener('click', (function (i) { return function () { stop(); go(i); }; })(k));
        dotsBox.appendChild(b);
        dots.push(b);
      }
    }
    var prev = root.querySelector('[data-mw-prev]');
    var next = root.querySelector('[data-mw-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(cur - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(cur + 1); });

    track.addEventListener('scroll', function () { clearTimeout(settle); settle = setTimeout(sync, 60); }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      root.addEventListener(ev, stop, { passive: true });
    });
    window.addEventListener('resize', function () { go(cur); });

    var ms = parseInt(root.dataset.mwAuto, 10);
    if (ms > 0 && !reduce) {
      timer = setInterval(function () { if (!document.hidden) go(cur + 1); }, ms);
    }
    sync();
  }

  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-mw-swipe]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();
